import { useTheme } from '@emotion/react'
import { Box, Button, Divider, Typography, Checkbox, CircularProgress } from '@mui/material'
import { IconHelpCircleFilled } from '@tabler/icons-react'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { Dialog } from '~/components/Dialog'
import { useContract } from '~/contexts'
import { useForInDeactivationContractMutation } from '~/graphql/types'

export type ContractUpdateStatusDialogProps = {
  isVisible: boolean
  toggleModal: () => void
}

export const ContractUpdateStatusDialog: React.FC<ContractUpdateStatusDialogProps> = ({ isVisible, toggleModal }) => {
  const theme = useTheme()
  const { contract, setContract } = useContract()
  const [acceptUpdateContractStatus, setAcceptUpdateContractStatus] = useState(false)
  const [canCreateInvoices, setCanCreateInvoices] = useState(true)

  const [updateContractStatus, { loading }] = useForInDeactivationContractMutation({
    onCompleted(updatedContract) {
      if (contract) {
        setContract({ ...contract, status: updatedContract.forInDeactivationContract.status, canCreateInvoices })
        toast.success('Status do contrato alterado com sucesso')
        toggleModal()
      }
    },
    onError() {
      toast.error('Erro ao alterar status do contrato.')
    },
  })

  return (
    <Dialog
      isVisible={isVisible}
      title='Alterar status do contrato'
      onClose={toggleModal}
      minWidth={700}
      titleIcon={<IconHelpCircleFilled style={{ color: theme.palette.primary.main }} size={32} />}
    >
      <Divider />
      <Box sx={{ display: 'flex', flexFlow: 'column', gap: '1rem', padding: '2rem 0' }}>
        <Typography variant='body1' lineHeight={'30px'}>Para alterar o status, certifique-se de que o status do contrato na <b>Gera</b> também esteja como <b>Em desativação.</b></Typography>

        <Box display='flex' flexDirection='row' alignItems='center' gap='8px'>
          <Checkbox onChange={() => setAcceptUpdateContractStatus(prev => !prev)} checked={acceptUpdateContractStatus} name='acceptUpdateContractStatus' />
          <Typography variant='body1' >Estou ciente de que ao confirmar esta ação, o cliente deixará de ser cobrado, ainda que o mesmo tenha pendências financeiras</Typography>
        </Box>

        <Box display='flex' flexDirection='row' alignItems='center' gap='8px'>
          <Checkbox onChange={() => setCanCreateInvoices(prev => !prev)} checked={canCreateInvoices} name='canCreateInvoices' />
          <Typography variant='body1' ><b>PERMITIR</b> criar novas faturas</Typography>
        </Box>

        <Typography>Deseja alterar o status do contrato para <b>Em desativação</b>?</Typography>
      </Box>
      <Divider />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '2rem' }}>
        <Button disabled={loading} onClick={toggleModal} color='secondary'>Cancelar</Button>
        <Button
          endIcon={loading ? <CircularProgress size={24} color='inherit' /> : null}
          disabled={!acceptUpdateContractStatus || loading}
          onClick={() => updateContractStatus({
            variables: {
              id: contract?._id || '',
              canCreate: canCreateInvoices
            }
          })}>
          Sim, alterar
        </Button>
      </Box>
    </Dialog>
  )
}
